export default "__VITE_ASSET__8554fce8__"